import { render, staticRenderFns } from "./DeveloperManage.vue?vue&type=template&id=8fe3ebfe&scoped=true"
import script from "./DeveloperManage.vue?vue&type=script&lang=js"
export * from "./DeveloperManage.vue?vue&type=script&lang=js"
import style0 from "./DeveloperManage.vue?vue&type=style&index=0&id=8fe3ebfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe3ebfe",
  null
  
)

export default component.exports